import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import Navbar from "./NavBar";
import { refreshAccessToken, AuthControl } from "./auth";

function TopluIzin() {
  const [personnelList, setPersonnelList] = useState([]);
  const [selectedSicil, setSelectedSicil] = useState("");
  const[topluIzinler,setTopluIzinler]= useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading_personnel, setLoadingPersonnel] = useState(true);
  const [user, setuser]=useState(null);
const [loading, set_Loading]=useState(false);
const [selectedList, setSelectedList] = useState([]);
const [formData, setFormData] = useState({
  MAVI: false,
  BEYAZ: false,
  IZIN_TUR: '',
  BASLANGIC_TARIH: '',
  BITIS_TARIH: '',
  YARIM1: false,
  YARIM2: false,
  ACIKLAMA: ''
});
  const [izinTurleri, setIzinTurleri] = useState([
      { ID: 1, name: "Doğum İzni" },
      { ID: 2, name: "Mazeret İzni"},
      { ID: 3, name: "Evlilik İzni"},
      { ID: 4, name: "Cenaze İzni"},
      { ID: 5, name: "Yıllık İzin"},
      { ID: 6, name: "İş Kazası"},
      { ID: 7, name: "Mazeretsiz"},
      { ID: 9, name: "Rapor" },
      { ID: 10, name: "Ücretsiz İzin" },
      { ID: 11, name: "Ücretli İzin" },
      { ID: 12, name: "Seyahat Raporu" },
      { ID: 13, name: "Süt İzni" },
      { ID: 14, name: "Görevli" },
      { ID: 15, name: "Babalık İzni" },
      { ID: 16, name: "Doğumgünü İzni" },
      { ID: 17, name: "Taşınma İzni" },
      { ID: 18, name: "Esnek Çalışma İzni" },
      { ID: 19, name: "Öğle Arası İzni" },
      { ID: 20, name: "Eğitim İzni" },
      { ID: 21, name: "Askerlik İzni" },
      { ID: 22, name: "Refakat İzni" },
      { ID: 23, name: "Uzaktan Çalışma İzni" }
    ]);

const handleAddSingle = (e) => {
  e.preventDefault();
  if (!selectedSicil) return;
  const person = personnelList.find(p => p.SICIL_NO === selectedSicil);
  if (person && !selectedList.find(p => p.SICIL_NO === selectedSicil)) {
    setSelectedList([...selectedList, person]);
  }
  setSelectedSicil('');
};

const handleRemovePerson = (sicil) => {
  setSelectedList(selectedList.filter(p => p.SICIL_NO !== sicil));
};

const handleAddByStatus = () => {
  const filtered = personnelList.filter(p => 
    (formData.Mavi && p.STATU === 'Mavi') ||
    (formData.Beyaz && p.STATU === 'Beyaz')
  );
  const unique = filtered.filter(p => !selectedList.find(sel => sel.SICIL_NO === p.SICIL_NO));
  setSelectedList([...selectedList, ...unique]);
};

const handleSubmitTopluIzin = async(e) => {
  e.preventDefault();
  if (!formData.IZIN_TUR || !formData.BASLANGIC_TARIH || !formData.BITIS_TARIH) {
    alert("Lütfen izin bilgilerini doldurun.");
    return;
  }
  set_Loading(true);
  try{
    const validation = validateIzinForm(formData);
    if (!validation.valid) {
      alert(validation.message);
      set_Loading(false);
      return;
    }
    let SICIL_LIST=null;
    if(selectedList.length>0)
      SICIL_LIST=selectedList.map(p=>p.SICIL_NO);
  const payload = {...formData, SICIL_LIST};
    //console.log("Sending:", payload);
  const response = await fetch(`/toplu_izin_kayit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({...payload})
    });

    //console.log('Response status:', response.status);
    if (response.ok) {
      alert('Toplu izin başarıyla kaydedildi');
      //const user = location.state?.user||JSON.parse(localStorage.getItem("user"));
      //sendLeaveNotification(user.SICIL_NO, user.ADI_SOYADI,formData.IZIN_TUR,formData.BASLANGIC_TARIH,formData.BITIS_TARIH );
    setFormData({
      IZIN_TUR: '',
      BASLANGIC_TARIH: '',
      BITIS_TARIH: '',
      ACIKLAMA:'',
      YARIM1: false,
      YARIM2: false
    });
  set_Loading(false);
}else {
      const errorData = await response.json();
      console.log('Error response:', errorData);  
      set_Loading(false);
      alert(`Hata: ${errorData.error || 'Kayıt hatası'}`);
    };
  }
  catch(err)
  {
    set_Loading(false);
  }
  finally{
    fetchTopluIzinler();
    set_Loading(false);
    
  }
}


    const countValidDays = (startDate, endDate, yarim1, yarim2) => {
      let count = 0;
      const date1 = new Date(startDate);
      date1.setHours(0,0,0,0);
      const date2 = new Date(endDate);
      date2.setHours(0,0,0,0);
      while (date1 <= date2) {
        const day = date1.getDay(); // 0 = Sunday
        if (day !== 0) count++;
        date1.setDate(date1.getDate() + 1);
      }
      if(yarim1) count = count - 0.5;
      if(yarim2) count = count - 0.5;
      //console.log("countvaliddays:",count);
      return count;
    };
  const validateIzinForm = (formData) => {
    const izinTurID = parseInt(formData.IZIN_TUR);
    const start = new Date(formData.BASLANGIC_TARIH);
    const end = new Date(formData.BITIS_TARIH);
    const yarim1 = formData.YARIM1;
    const yarim2 = formData.YARIM2;
  
    if (isNaN(izinTurID) || !formData.BASLANGIC_TARIH || !formData.BITIS_TARIH) {
      return { valid: false, message: "Lütfen izin türünü ve tarihleri seçin." };
    }
  
    if (end < start) {
      return { valid: false, message: "Bitiş tarihi başlangıç tarihinden önce olamaz." };
    }
  if (formData.YARIM1 && formData.YARIM2 && start.getTime()===end.getTime()) {
      return { valid: false, message: "Tek günlük izinlerde hem başlangıç hem bitiş yarım gün olamaz." };
    }
    // Count days excluding Sundays (and optionally Saturdays for specific cases)
    
  const gun = countValidDays(start, end, yarim1,yarim2);
    // --- İzin kuralları ---
    if(gun<=0)
      return { valid: false, message: "İzin aralığı geçersiz. Kontrol ediniz." };
    if (izinTurID === 1) { // Doğum İzni
      
      if (gun > 96) {//Pazarlar sayılmıyor (16 hafta * 6)
        return { valid: false, message: "Doğum izni en fazla 16 hafta olabilir." };
      }
    }
    
    if (izinTurID === 3) { // Evlilik İzni
      
      if (gun > 3) {
        return { valid: false, message: "Evlilik izni en fazla 3 gün olabilir." };
      }
    }
    if (izinTurID === 4) { // Cenaze İzni
     
      if (gun > 3) {
        return { valid: false, message: "Cenaze izni en fazla 3 gün olabilir." };
      }
    }
    if (izinTurID === 15) { // Babalık İzni
      
      if (gun > 5) {
        return { valid: false, message: "Babalık izni en fazla 5 gün olabilir." };
      }
    }
    if (izinTurID === 16) { // Doğum günü İzni
      
      if (gun > 1) {
        return { valid: false, message: "Doğum günü izni en fazla 1 gün olabilir." };
      }
    }
    if (izinTurID === 17) { // Taşınma İzni
      
      if (gun > 1) {
        return { valid: false, message: "Taşınma izni en fazla 1 gün olabilir." };
      }
    }
    // Kurallar bitti...
  console.log("Count valid days:",gun);
    return { valid: true }; // sorun yok
  };

  useEffect(() => {
      async function init() {
        const success = await refreshAccessToken();
        if (!success) {
          console.log('Refresh failed, redirected to login.');
          return;
        }
    
        try {
          const res = await fetch('/me', { credentials: 'include' });
          const data = await res.json();
          if (res.ok) {
            if (data.sicil_no) {
              //setFormData((prevData) => ({ ...prevData, SICIL_NO: data.SICIL_NO }));
              setuser(data);
              //fetchIzinler(data);
            } else {
              console.error("Sicil bilgisi bulunamadı");
            }
          } else {
            console.error("User fetch error:", data.error);
          }
        } catch (err) {
          console.error("User fetch exception:", err);
        }
      }
    
      init();
    }, []);
  useEffect(() => {
    // Fetch personnel list on page load
    const fetchPersonnel = async () => {
      try {
        const response = await fetch("/personel_listesi");
        if (!response.ok) {
            const text = await response.text();
            await AuthControl(response,navigate);
            throw new Error(text || "Personel listesi alınamadı");
          }
          const data = await response.json();
        setPersonnelList(data);
        setLoadingPersonnel(false); //personel yükleme tamam
      } catch (err) {
        setError(err.message);
      }
    };
    fetchPersonnel();
    fetchTopluIzinler();
  }, []);

  const fetchTopluIzinler = async (sicilNo) => {
    try {
        const response = await fetch(`/toplu_izin_getir`);
        
        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || "Toplu izinler alınamadı");
          }
          const data = await response.json();
          setTopluIzinler(data);

    }catch (err) {
        setError(err.message);
      }
  };

  

const handleDeleteToplu = async (baslangic, bitis,talep_gun, aciklama) => {
    
    if(!user)
    {
      alert("Kullanıcı bilgisine ulaşılamıyor. Yeniden giriş yapınız.");
      return;
    }

    const confirm = window.confirm("Bu izni silmek istediğinize emin misiniz?");
    if (!confirm) return;
    set_Loading(true);
    try {
      const response = await fetch(`/toplu_izin_sil/`, {
        method: "POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({BASLANGIC_TARIH:baslangic, BITIS_TARIH:bitis,TALEP_GUN:talep_gun,ACIKLAMA:aciklama})
      });
      
      if (response.ok) {
        window.alert("Toplu izin kaydı silindi.");
        
      
      fetchTopluIzinler();
      
      } else {
        const error = await response.json();
        window.alert(`Hata: ${error.message || "Silme işlemi başarısız."}`);
      }
    } catch (err) {
      console.error("Silme hatası:", err);
      window.alert("Sunucu hatası oluştu.");
    }
    finally{
    fetchTopluIzinler();
    set_Loading(false);
  }
  };

  
  return (
    <div>
   
    <div className="container">
       <Navbar />
  <h1>Toplu İzin Girişi</h1>

  {/* Status-based selection */}
  <section>
    <h2>Statüye Göre Seçim</h2>
    <label style={{marginRight:"15px"}}>
      <input
        type="checkbox"
        checked={formData.MAVI}
        onChange={(e) => setFormData({ ...formData, MAVI: e.target.checked })}
      />
      Mavi Yaka
    </label>
    <label>
      <input
        type="checkbox"
        checked={formData.BEYAZ}
        onChange={(e) => setFormData({ ...formData, BEYAZ: e.target.checked })}
      />
      Beyaz Yaka
    </label>
    
  </section>

  {/* Individual selection */}
  <section disabled={formData.MAVI||formData.BEYAZ}>
    <h2>Tekil Seçim</h2>
    <label>Personel Seçiniz:</label>
    <select
      value={selectedSicil}
      onChange={(e) => setSelectedSicil(e.target.value)}
      disabled={loading_personnel}
    >
      {loading_personnel ? (
        <option>Yükleniyor...</option>
      ) : (
        <>
          <option value="">-- Seçiniz --</option>
          {personnelList.map((p) => (
            <option key={p.SICIL_NO} value={p.SICIL_NO}>
              {p.ADI_SOYADI}
            </option>
          ))}
        </>
      )}
    </select>
    <button onClick={handleAddSingle}>Ekle</button>
  </section>

  {/* Selected list display */}
  {selectedList.length > 0 && (
    <section>
      <h2>Seçilen Personeller</h2>
      <ul>
        {selectedList.map((person) => (
          <li key={person.SICIL_NO}>
            {person.ADI_SOYADI} ({person.SICIL_NO})
            <button disabled = {(formData.MAVI||formData.BEYAZ)} onClick={() => handleRemovePerson(person.SICIL_NO)}>Kaldır</button><>{(formData.MAVI||formData.BEYAZ)&&(<label style={{color:'red'}}>Statü seçimi ile birlikte kullanılamaz</label>)}</>
          </li>
        ))}
      </ul>
    </section>
  )}

  {/* Leave details */}
  {(selectedList.length > 0||formData.MAVI||formData.BEYAZ) && (
    <section>
      <h2>İzin Detayları</h2>
      <form onSubmit={handleSubmitTopluIzin}>
        <label>İzin Türü</label>
        <select
          value={formData.IZIN_TUR}
          onChange={(e) => setFormData({ ...formData, IZIN_TUR: e.target.value })}
        >
          <option value="">-- Seçiniz --</option>
          {izinTurleri.map((tur) => (
            <option key={tur.ID} value={tur.ID}>
              {tur.name}
            </option>
          ))}
        </select>

        <label>Başlangıç Tarihi</label>
        <input
          type="date"
          value={formData.BASLANGIC_TARIH}
          onChange={(e) => setFormData({ ...formData, BASLANGIC_TARIH: e.target.value })}
        />

        <label>
          <input
            type="checkbox"
            checked={formData.YARIM1}
            onChange={(e) => setFormData({ ...formData, YARIM1: e.target.checked })}
          />
          Yarım Gün
        </label>

        <label>Bitiş Tarihi</label>
        <input
          type="date"
          value={formData.BITIS_TARIH}
          onChange={(e) => setFormData({ ...formData, BITIS_TARIH: e.target.value })}
        />

        <label>
          <input
            type="checkbox"
            checked={formData.YARIM2}
            onChange={(e) => setFormData({ ...formData, YARIM2: e.target.checked })}
          />
          Yarım Gün
        </label>

        <label>Açıklama</label>
        <textarea
          value={formData.ACIKLAMA}
          onChange={(e) => setFormData({ ...formData, ACIKLAMA: e.target.value })}
          rows="3"
        />

        <button type="submit" disabled = {loading}>{loading? "Kaydediliyor...":"Toplu İzin Gönder"}</button>
      </form>
    </section>
  )}
  {topluIzinler.length > 0 ?(<>
            <h2>Toplu İzin Geçmişi</h2>
            <div className="table_wrapper">
            <table>
              <thead>
                <tr>
                  <th>Başlangıç</th>
                  <th>Bitiş</th>
                  <th>Talep Edilen Gün</th>
                  <th>Açıklama/Gerekçe</th>
                  <th>Kapsam</th>
                  <th>Sil</th>
                </tr>
              </thead>
              <tbody>
                {topluIzinler.map((izin) => (
                  <tr key={izin.ID}>
                    <td>{new Date(izin.BASLANGIC_TARIH).toLocaleDateString('tr-TR')}</td>
                    <td>{new Date(izin.BITIS_TARIH).toLocaleDateString('tr-TR')}</td>
                    <td>{izin.TALEP_GUN}</td>
                    <td>{izin.ACIKLAMA}</td>
                    <td>{izin.IK_NOT}</td>
                    <td>
                      <td>{(<button onClick={() => handleDeleteToplu(izin.BASLANGIC_TARIH,izin.BITIS_TARIH,izin.TALEP_GUN,izin.ACIKLAMA)}>🗑️</button>)}</td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div></>):(
            <p>Toplu izin kaydı bulunamadı.</p>
          )
          }
</div>


       
        
      
    </div>

  );
}

export default TopluIzin;